import { render } from "./AddManagerBookingPage.vue?vue&type=template&id=d52486a0&ts=true"
import script from "./AddManagerBookingPage.vue?vue&type=script&lang=ts"
export * from "./AddManagerBookingPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__